import React from 'react';
import i18next from 'i18next';
import classNames from 'classnames';
import Spinner from 'react-spinkit';
import Dropdown from '../Dropdown/Dropdown';
import { Scrollbars } from 'react-custom-scrollbars';
import Api from '../../api';
import { betStatus, numberWithSpaces } from '../../utils';
import format from 'date-fns/format';
import parse from 'date-fns/parse';
import EApi from '../../api/esports';
import makeCancelable from '../../api/cancelable';
import { connect } from 'react-redux';

class OperationsHistory extends React.Component {
  static defaultProps = {
    defaultTab: 'orders',
  };

  constructor(props) {
    super(props);

    this.state = {
      orders: [],
      withdraws: [],
      deposites: [],
      withdraws_crypto: [],
      deposites_crypto: [],
      coupons: [],
      pending: true,
      filters: {
        operationsType: null,
      },
    };

    this.requests = [];
  }

  componentDidMount() {
    this.onFilterChange('operationsType', { value: this.props.defaultTab });
  }

  componentWillUnmount() {
    this.requests.forEach((cancel) => cancel());
  }

  onFilterChange = (type, selected) => {
    if (
      type === 'operationsType' &&
      this.state.filters.operationsType !== selected.value
    ) {
      if (selected.value === 'orders') this.loadOrders();
     if (selected.value === 'withdraw') this.loadWithdraws();
     if (selected.value === 'deposit') this.loadDeposites();
      if (selected.value === 'withdraw_crypto') this.loadWithdrawsCrypto();
      if (selected.value === 'deposit_crypto') this.loadDepositesCrypto();
      if (selected.value === 'bets') this.loadBets();

      this.setState({ pending: true });
    }

    if (this.state.filters[type] !== selected.value) {
      this.setState({
        orders: [],
        withdraws: [],
        deposites: [],
        withdrawsCrypto: [],
        depositesCrypto: [],
        filters: {
          ...this.state.filters,
          [type]: selected.value,
        },
      });
    }
  };

  onWithdrawCancel = (withdraw) => {
    const confirmed = confirm(i18next.t('operations_history.cancel_confirm'));
    if (!confirmed) return;

    const { promise, cancel } = makeCancelable(Api.withdrawCancel(withdraw.id));
    this.requests.push(cancel);

    promise.then((response) => {
      if (response.status === 'success') {
        this.loadWithdraws();
      } else {
        alert(i18next.t('api.retry_error'));
      }
    });
  };

  loadOrders = () => {
    const { promise, cancel } = makeCancelable(Api.ordersHistory());
    this.requests.push(cancel);

    promise.then((response) => {
      if (response.status === 'success') {
        this.setState({
          orders: response.data,
          pending: false,
        });
      }
    });
  };

  loadWithdraws = () => {
    const { promise, cancel } = makeCancelable(Api.withdrawHistory());
    this.requests.push(cancel);

    promise.then((response) => {
      if (response.status === 'success') {
        this.setState({
          withdraws: response.data,
          pending: false,
        });
      }
    });
  };

  loadDeposites = () => {
    const { promise, cancel } = makeCancelable(Api.depositHistory());
    this.requests.push(cancel);

    promise.then((response) => {
      if (response.status === 'success') {
        this.setState({
          deposites: response.data,
          pending: false,
        });
      }
    });
  };

  loadWithdrawsCrypto = () => {
    const { promise, cancel } = makeCancelable(Api.withdrawHistoryCrypto());
    this.requests.push(cancel);

    promise.then((response) => {
      if (response.status === 'success') {
        this.setState({
          withdrawsCrypto: response.data,
          pending: false,
        });
      }
    });
  };

  loadDepositesCrypto = () => {
    const { promise, cancel } = makeCancelable(Api.depositHistoryCrypto());
    this.requests.push(cancel);

    promise.then((response) => {
      if (response.status === 'success') {
        this.setState({
          depositesCrypto: response.data,
          pending: false,
        });
      }
    });
  };

  loadBets = () => {
    const { promise, cancel } = makeCancelable(EApi.couponHistory());
    this.requests.push(cancel);

    promise.then((response) => {
      if (response.status === 'success') {
        this.setState({
          coupons: response.data,
          pending: false,
        });
      }
    });
  };

  renderWithdrawsTable() {
    const { withdraws, pending } = this.state;
    const STATUS_PENDING = 0;
    const STATUS_DONE = 1;
    const STATUS_CANCELLED = 3;

    const t = (status) =>
      i18next.t(`operations_history.withdraw.statuses.${status}`);

    const statusText = (item) => {
      if (item.status === STATUS_PENDING) return t('pending');
      if (item.status === STATUS_DONE) return t('done');
      if (item.status === STATUS_CANCELLED) return t('cancelled');
      return t('error');
    };

    return (
      <div className="table">
        <div className="table__header">
          <span className="table__col">
            {i18next.t('operations_history.withdraw.time')}
          </span>
          <span className="table__col">
            {i18next.t('operations_history.withdraw.sum')}
          </span>
          <span className="table__col">
            {i18next.t('operations_history.withdraw.status')}
          </span>
        </div>
        <div className="table__body">
          <Scrollbars
            hideTracksWhenNotNeeded={true}
            autoHeight={true}
            autoHeightMax={300}
            renderView={(props) => <div {...props} className="table__rows" />}
          >
            {pending && (
              <Spinner name="ball-clip-rotate" color="white" fadeIn="quarter" />
            )}
            {withdraws.map((item, i) => (
              <div key={i}>
                <span className="table__col">
                  {format(parse(item.addtime), 'DD.MM.YYYY HH:mm')}
                </span>
                <span className="table__col">{item.sum}</span>
                <span
                  className={
                    'table__col' +
                    (item.status === STATUS_DONE
                      ? ' win'
                      : item.status === STATUS_CANCELLED
                      ? ' loose'
                      : ' pending')
                  }
                >
                  {statusText(item)}

                  {/* {item.status === STATUS_PENDING && (
                    <Icon
                      glyph={closeIcon}
                      onClick={this.onWithdrawCancel.bind(this, item)}
                      className="operations-history__withdraw-close"
                      title={i18next.t('operations_history.withdraw.cancel')}
                    />
                  )} */}
                </span>
              </div>
            ))}
            {!pending && !withdraws.length && (
              <div className="operations-history__empty">
                {i18next.t('operations_history.withdraw.empty')}
              </div>
            )}
          </Scrollbars>
        </div>
      </div>
    );
  }

  renderDepositsTable() {
    const { deposites, pending } = this.state;

    return (
      <div className="table">
        <div className="table__header">
          <span className="table__col">
            {i18next.t('operations_history.deposit.time')}
          </span>
          <span className="table__col">
            {i18next.t('operations_history.deposit.sum')}
          </span>
          <span className="table__col">
            {i18next.t('operations_history.deposit.status')}
          </span>
        </div>
        <div className="table__body">
          <Scrollbars
            hideTracksWhenNotNeeded={true}
            autoHeight={true}
            autoHeightMax={300}
            renderView={(props) => <div {...props} className="table__rows" />}
          >
            {pending && (
              <Spinner name="ball-clip-rotate" color="white" fadeIn="quarter" />
            )}
            {deposites.map((item, i) => (
              <div key={i}>
                <span className="table__col">
                  {format(parse(item.addtime), 'DD.MM.YYYY HH:mm')}
                </span>
                <span className="table__col">{item.amount}</span>
                <span
                  className={
                    'table__col' +
                    (item.status === 1
                      ? ' win'
                      : item.status === -1
                      ? ' loose'
                      : ' pending')
                  }
                >
                  {i18next.t(
                    `operations_history.deposit.statuses.${
                      item.status === 1
                        ? 'done'
                        : item.state === -1
                        ? 'cancelled'
                        : 'pending'
                    }`
                  )}
                </span>
              </div>
            ))}
            {!pending && !deposites.length && (
              <div className="operations-history__empty">
                {i18next.t('operations_history.deposit.empty')}
              </div>
            )}
          </Scrollbars>
        </div>
      </div>
    );
  }

  renderWithdrawsCryptoTable() {
    const { withdrawsCrypto, pending } = this.state;
    const STATUS_PENDING = 0;
    const STATUS_STARTED = 1;
    const STATUS_CANCELLED = 2;
    const STATUS_SENT = 3;
    const STATUS_DONE = 4;
    const STATUS_ERROR = 5;

    const t = (status) =>
      i18next.t(`operations_history.withdraw_crypto.statuses.${status}`);

    const statusText = (status) => {
      if (status === STATUS_PENDING) return t('pending');
      if (status === STATUS_STARTED) return t('started');
      if (status === STATUS_CANCELLED) return t('cancelled');
      if (status === STATUS_SENT) return t('sent');
      if (status === STATUS_DONE) return t('done');
      if (status === STATUS_ERROR) return t('error');
      return t('error');
    };

    const statusClassName = (status) => {
      if (status === STATUS_DONE) return 'win';
      if ([STATUS_CANCELLED, STATUS_ERROR].includes(status)) return 'loose';
      return 'pending';
    };

    return (
      <div className="table withdraw-crypto-table">
        <div className="table__header">
          <span className="table__col">
            {i18next.t('operations_history.withdraw_crypto.time')}
          </span>
          <span className="table__col">
            {i18next.t('operations_history.withdraw_crypto.amount')}
          </span>
          <span className="table__col">
            {i18next.t('operations_history.withdraw_crypto.status')}
          </span>
        </div>
        <div className="table__body">
          <Scrollbars
            hideTracksWhenNotNeeded={true}
            autoHeight={true}
            autoHeightMax={300}
            renderView={(props) => <div {...props} className="table__rows" />}
          >
            {pending && (
              <Spinner name="ball-clip-rotate" color="white" fadeIn="quarter" />
            )}
            {withdrawsCrypto.map((item, i) => (
              <div key={i}>
                <span className="table__col">{item.addtime}</span>
                <span className="table__col operations-history--withdraw_crypto__amount">
                  <span>{item.amount} REX</span>
                  <span title={item.address}>
                    {item.crypto_amount} {item.symbol}
                  </span>
                </span>
                <span
                  className={classNames(
                    'table__col',
                    statusClassName(item.status)
                  )}
                >
                  {statusText(item.status)}
                </span>
              </div>
            ))}
            {!pending && !withdrawsCrypto.length && (
              <div className="operations-history__empty">
                {i18next.t('operations_history.withdraw_crypto.empty')}
              </div>
            )}
          </Scrollbars>
        </div>
      </div>
    );
  }

  renderDepositsCryptoTable() {
    const { depositesCrypto, pending } = this.state;

    const STATUS_NOT_CONFIRMED = 0;
    const STATUS_DONE = 1;

    const t = (status) =>
      i18next.t(`operations_history.deposit_crypto.statuses.${status}`);

    const statusText = (status) => {
      if (status === STATUS_DONE) return t('done');
      if (status === STATUS_NOT_CONFIRMED) return t('not_confirmed');
      return t('error');
    };

    const statusClassName = (status) => {
      if (status === STATUS_DONE) return 'win';
      if (status === STATUS_NOT_CONFIRMED) return 'loose';
      return 'pending';
    };

    return (
      <div className="table">
        <div className="table__header">
          <span className="table__col">
            {i18next.t('operations_history.deposit_crypto.time')}
          </span>
          <span className="table__col">
            {i18next.t('operations_history.deposit_crypto.amount')}
          </span>
          <span className="table__col">
            {i18next.t('operations_history.deposit_crypto.status')}
          </span>
        </div>
        <div className="table__body">
          <Scrollbars
            hideTracksWhenNotNeeded={true}
            autoHeight={true}
            autoHeightMax={300}
            renderView={(props) => <div {...props} className="table__rows" />}
          >
            {pending && (
              <Spinner name="ball-clip-rotate" color="white" fadeIn="quarter" />
            )}
            {depositesCrypto.map((item, i) => (
              <div key={i}>
                <span className="table__col">{item.addtime}</span>
                <span className="table__col operations-history--deposit_crypto__amount">
                  <span>{item.amount} REX</span>
                  <span>
                    {item.crypto_amount} {item.symbol}
                  </span>
                </span>
                <span
                  className={classNames(
                    'table__col',
                    statusClassName(item.status)
                  )}
                >
                  {statusText(item.status)}
                </span>
              </div>
            ))}
            {!pending && !depositesCrypto.length && (
              <div className="operations-history__empty">
                {i18next.t('operations_history.deposit_crypto.empty')}
              </div>
            )}
          </Scrollbars>
        </div>
      </div>
    );
  }

  renderOrdersTable() {
    const { orders, pending } = this.state;
    return (
      <div className="table">
        <div className="table__header">
          <span className="table__col">
            {i18next.t('operations_history.orders.time')}
          </span>
          <span className="table__col">
            {i18next.t('operations_history.orders.sum')}
          </span>
          <span className="table__col">
            {i18next.t('operations_history.orders.x')}
          </span>
          <span className="table__col">
            {i18next.t('operations_history.orders.profit')}
          </span>
        </div>
        <div className="table__body">
          <Scrollbars
            hideTracksWhenNotNeeded={true}
            autoHeight={true}
            autoHeightMax={300}
            renderView={(props) => <div {...props} className="table__rows" />}
          >
            {pending && (
              <Spinner name="ball-clip-rotate" color="white" fadeIn="quarter" />
            )}
            {orders.map((item, i) => (
              <div key={i}>
                <span className="table__col">
                  {item.addtime.slice(item.addtime.indexOf('-') + 1)}
                </span>
                <span className="table__col">{item.summ}</span>
                <span className="table__col">
                  {+item.status ? item.price : 0}
                </span>
                <span
                  className={
                    'table__col' + (+item.status === 1 ? ' win' : ' loose')
                  }
                >
                  {+item.status
                    ? '+' + numberWithSpaces(Math.floor(item.summ * item.price))
                    : -item.summ}
                </span>
              </div>
            ))}
            {!pending && !orders.length && (
              <div className="operations-history__empty">
                {i18next.t('operations_history.orders.empty')}
              </div>
            )}
          </Scrollbars>
        </div>
      </div>
    );
  }

  renderBetsTable() {
    const { coupons, pending } = this.state;
    return (
      <div className="bets-history">
        <Scrollbars
          hideTracksWhenNotNeeded={true}
          autoHeight={true}
          autoHeightMax={400}
          renderView={(props) => <div {...props} />}
        >
          {pending && (
            <Spinner name="ball-clip-rotate" color="white" fadeIn="quarter" />
          )}
          {Object.keys(coupons).map((couponId, i) => {
            const item = coupons[couponId];

            const statusText = betStatus(item['message']);

            return (
              <div
                key={i}
                className={classNames('bets-history__coupon', {
                  express: item['bets'].length > 1,
                })}
              >
                <div className="bets-history__time">{item['addtime']}</div>
                <div className="bets-history__bets">
                  {item['bets'].map((bet, i) => (
                    <div className="bets-history__bet" key={i}>
                      <div>
                        <div className="bets-history__event_name">
                          {bet['ev_name'] ||
                            i18next.t('operations_history.bets.no_ev_name')}
                        </div>
                        <div className="bets-history__bet-name">
                          {bet['market_title']}, {bet['bet_name']}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
                <div className="bets-history__info">
                  <div className="bets-history__cf">{item['sum_cf']}</div>
                  <div className="bets-history__amount">{`${item['amount']} REX`}</div>
                </div>
                <div className={classNames('bets-history__result', statusText)}>
                  {statusText === 'win' && (
                    <div className="text-icon">
                      {/*<Icon className="text-icon__icon" glyph={ rexPlusIcon }/>*/}
                      <img
                        className="text-icon__icons"
                        src={`${app.assetsPath}/images/rex_plus.png`}
                      />
                      {`+ ${Math.floor(item['reward'])} REX`}
                    </div>
                  )}

                  {statusText === 'refund' && (
                    <div className="text-icon">
                      {/*<Icon className="text-icon__icon" glyph={ rexRefundIcon }/>*/}
                      <img
                        className="text-icon__icon"
                        src={`${app.assetsPath}/images/rex_refund.png`}
                      />
                      {i18next.t('operations_history.bets.statuses.cancelled')}
                    </div>
                  )}

                  {statusText === 'loose' && (
                    <div className="text-icon">
                      {/*<Icon className="text-icon__icon" glyph={ rexMinusIcon }/>*/}
                      <img
                        className="text-icon__icon"
                        src={`${app.assetsPath}/images/rex_minus.png`}
                      />
                      {`- ${item['amount']} REX`}
                    </div>
                  )}

                  {statusText === 'pending' && (
                    <div className="text-icon">
                      {/*<Icon className="text-icon__icon" glyph={ rexRefundIcon }/>*/}
                      <img
                        className="text-icon__icon"
                        src={`${app.assetsPath}/images/rex_refund.png`}
                      />

                      {i18next.t('operations_history.bets.statuses.pending')}
                    </div>
                  )}
                </div>
              </div>
            );
          })}
          {!pending && !Object.keys(coupons).length && (
            <div className="operations-history__empty">
              {i18next.t('operations_history.bets.empty')}
            </div>
          )}
        </Scrollbars>
      </div>
    );
  }

  render() {
    const { filters } = this.state;

    return (
      <div
        className={classNames(
          'operations-history',
          `operations-history--${filters.operationsType}`
        )}
      >
        <OperationsFilters
          onChange={this.onFilterChange}
          values={filters}
          cryptoEnabled={this.props.cryptoEnabled}
        />
        {filters.operationsType === 'withdraw' && this.renderWithdrawsTable()}
        {filters.operationsType === 'deposit' && this.renderDepositsTable()}
        {filters.operationsType === 'withdraw_crypto' &&
          this.renderWithdrawsCryptoTable()}
        {filters.operationsType === 'deposit_crypto' &&
          this.renderDepositsCryptoTable()}
        {filters.operationsType === 'orders' && this.renderOrdersTable()}
        {filters.operationsType === 'bets' && this.renderBetsTable()}
      </div>
    );
  }
}

class OperationsFilters extends React.Component {
  render() {
    const { values, onChange, cryptoEnabled } = this.props;
    return (
      <div className="operations-history__filters">
        <Dropdown
          value={values.operationsType}
          placeholder={i18next.t('operations_history.type')}
          onChange={onChange.bind(this, 'operationsType')}
          options={[
            {
              value: 'withdraw',
              label: i18next.t('operations_history.withdraw.title'),
            },
            {
              value: 'deposit',
              label: i18next.t('operations_history.deposit.title'),
            },
            cryptoEnabled && {
              value: 'withdraw_crypto',
              label: i18next.t('operations_history.withdraw_crypto.title'),
            },
            cryptoEnabled && {
              value: 'deposit_crypto',
              label: i18next.t('operations_history.deposit_crypto.title'),
            },
            {
              value: 'orders',
              label: i18next.t('operations_history.orders.title'),
            },
            {
              value: 'bets',
              label: i18next.t('operations_history.bets.title'),
            },
          ].filter(Boolean)}
        />
      </div>
    );
  }
}

export default connect((state) => {
  return {
    cryptoEnabled: Boolean(state.user.profile.crypto),
  };
}, {})(OperationsHistory);



// WEBPACK FOOTER //
// ./app/components/OperationsHistory/OperationsHistory.jsx